import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  subtitle, 
  trend, 
  trendValue, 
  icon, 
  color = 'primary',
  loading = false 
}) => {
  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return {
          bg: 'bg-success/10',
          icon: 'text-success',
          trend: trend === 'up' ? 'text-success' : 'text-error'
        };
      case 'warning':
        return {
          bg: 'bg-warning/10',
          icon: 'text-warning',
          trend: trend === 'up' ? 'text-success' : 'text-error'
        };
      case 'error':
        return {
          bg: 'bg-error/10',
          icon: 'text-error',
          trend: trend === 'up' ? 'text-success' : 'text-error'
        };
      default:
        return {
          bg: 'bg-primary/10',
          icon: 'text-primary',
          trend: trend === 'up' ? 'text-success' : 'text-error'
        };
    }
  };

  const colorClasses = getColorClasses();

  if (loading) {
    return (
      <div className="bg-card border border-border rounded-lg p-6 animate-pulse">
        <div className="flex items-center justify-between mb-4">
          <div className="w-8 h-8 bg-muted rounded-lg" />
          <div className="w-16 h-4 bg-muted rounded" />
        </div>
        <div className="space-y-2">
          <div className="w-20 h-8 bg-muted rounded" />
          <div className="w-32 h-4 bg-muted rounded" />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-moderate transition-smooth">
      <div className="flex items-center justify-between mb-4">
        <div className={`w-12 h-12 ${colorClasses?.bg} rounded-lg flex items-center justify-center`}>
          <Icon name={icon} size={24} className={colorClasses?.icon} />
        </div>
        
        {trend && trendValue && (
          <div className={`flex items-center space-x-1 ${colorClasses?.trend}`}>
            <Icon 
              name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
              size={16} 
            />
            <span className="text-sm font-medium">{trendValue}</span>
          </div>
        )}
      </div>
      <div className="space-y-1">
        <h3 className="text-2xl font-bold text-foreground">{value}</h3>
        <p className="text-sm text-muted-foreground">{title}</p>
        {subtitle && (
          <p className="text-xs text-muted-foreground">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default MetricCard;